import React from "react";
import {
  NotificationSettings,
  NotificationPanel,
} from "@/components/molecules/notifications";
import { UiButton } from "@/components/ui";
import { useNotifications } from "@/hooks/useNotifications";

const ProfileNotificationsPage: React.FC = () => {
  const { requestNotificationPermission } = useNotifications();

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Profil - Notifications
        </h1>
        <p className="text-gray-600">
          Gérez vos préférences de notifications et consultez vos notifications
          récentes.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Paramètres de notifications */}
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <NotificationSettings />
        </div>

        {/* Panel des notifications */}
        <div className="bg-white rounded-lg border border-gray-200">
          <NotificationPanel />
        </div>
      </div>
    </div>
  );
};

export default ProfileNotificationsPage;
